'use client';

import Script from 'next/script';
import React, { useState, useEffect } from 'react';
import facebookTPScript from '../../../lib/util/facebookTP';
import { isUserInChina } from '../../../lib/util/isUserInChina';

/**
 * Facebook script.
 */
const FacebookScript = () => {
  const [shouldRender, setShouldRender] = useState<boolean | null>(null);

  useEffect(() => {
    const checkLocation = async () => {
      try {
        const isInChina = await isUserInChina();
        setShouldRender(!isInChina);
      } catch (error) {
        setShouldRender(true);
      }
    };

    checkLocation();
  }, []);

  // Don't render anything while checking location
  if (shouldRender === null) {
    return null;
  }

  // Don't render if user is in China
  if (!shouldRender) {
    return null;
  }

  return (
    <>
      <Script
        id="facebookTPScript"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: facebookTPScript(),
        }}
      />
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${process.env.NEXT_PUBLIC_FB_PIXEL_ID}&ev=PageView&noscript=1" />`,
        }}
      />
    </>
  );
};

export default FacebookScript;
